<div class="">
  <button (click)="openMenu()">
    <mat-icon fontSet="material-icons-outlined">person</mat-icon>
  </button>
  <div
    (click)="stopPropagation($event)"
    class="hiddenMenu" [ngClass]="{'open': showMenu}"
    (keydown.enter)="impersonate(impersonatedUsername)"
  >
    <app-weave-input
        [label]="''"
        [placeholder]="'Impersonate User'"
        [data]="impersonatedUsername"
        (keyUp)="updateUser($event)"
    ></app-weave-input>
    <button
      [disabled]="!impersonatedUsername"
      type="submit"
      (click)="impersonate(impersonatedUsername)"
      class="button"
    >
      Go
    </button>
  </div>
</div>
